import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useEffect, useState } from "react";
import { BiSolidHide, BiSolidShow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { fetchAllClients } from "../../Redux/WhatsappSlice/Client";
import { fetchDocumentLinkAll } from "../../Redux/WhatsappSlice/DocumentLinkSetup";
import { fetchTemplates } from "../../Redux/WhatsappSlice/Template";
import { fetchWpSetupAll } from "../../Redux/WhatsappSlice/WhatsappApiSetup";
import {
  AddOfficialWARegistration,
  CheckWAConnection,
} from "../../Redux/WhatsappSlice/WhatsAppRegistration";

const WhatsAppRegistration = () => {
  const dispatch = useDispatch();

  const { AllClients } = useSelector((state) => state.Client);
  const { WpSetupData } = useSelector((state) => state.WpApiSetup);
  const { DocumentLinks } = useSelector((state) => state.DocumentLinkSetup);
  const { TemplateData } = useSelector((state) => state.Template);


  const [formData, setFormData] = useState({
    WhaClientName: "",
    UserName: "",
    Password: "",
    WhatsAppOffcialWa: "",
    DocLink: "",
    Templates: [],
    WhaCount: 0,
    WhaBalCount: 0,
    IsAdmin: false,
    IsActive: false,
    IsOWNWhatsapp: false,
    WhatsappBot: false,
    Database: "",
    Port: "",
    FolderName: "",
    WappNo: "",
    APIToken: "",
    PhoneNoID: "",
    VerifyToken: "",
    Server: "",

  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    dispatch(fetchAllClients());
    dispatch(fetchWpSetupAll());
    dispatch(fetchDocumentLinkAll());
    dispatch(fetchTemplates());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = (formData) => {
    const errors = {};

    if (!formData.WhaClientName || formData.WhaClientName.trim() === "") {
      errors.WhaClientName = "Client name is required";
    }

    if (
      !formData.WhatsAppOffcialWa ||
      formData.WhatsAppOffcialWa.length === 0
    ) {
      errors.WhatsAppOffcialWa = "WP API Setup Client is required";
    }

    if (!formData.UserName || formData.UserName.trim() === "") {
      errors.UserName = "Username is required";
    }

    if (!formData.Password || formData.Password.trim() === "") {
      errors.Password = "Password is required";
    }

    if (!formData.Password || formData.Password.trim() === "") {
      errors.Password = "Password is required";
    }

    if (!formData.FolderName || formData.FolderName.trim() === "") {
      errors.FolderName = "Folder Name is required";
    }

    if (!formData.Templates || formData.Templates.length === 0) {
      errors.Templates = "At least one template must be selected";
    }

    if (!formData.DocLink || formData.DocLink.length === 0) {
      errors.DocLink = "Document Link Main Client is required";
    }

    if (!formData.Database || formData.Database.trim() === "") {
      errors.Database = "Database is required";
    }

    if (
      formData.Port === "" ||
      formData.Port === null ||
      isNaN(formData.Port) ||
      Number(formData.Port) <= 0 ||
      !Number.isInteger(Number(formData.Port))
    ) {
      errors.Port = "Port is required and must be a positive integer";
    }

    if (!formData.FolderName || formData.FolderName.trim() === "") {
      errors.FolderName = "Folder Name is required";
    }

    if (formData.WhatsappBot) {
      if (!formData.WappNo || formData.WappNo.trim() === "") {
        errors.WappNo = "WappNo is required";
      }
      if (!formData.APIToken || formData.APIToken.trim() === "") {
        errors.APIToken = "API Token is required";
      }
      if (!formData.PhoneNoID || formData.PhoneNoID.trim() === "") {
        errors.PhoneNoID = "Phone No ID is required";
      }
      if (!formData.VerifyToken || formData.VerifyToken.trim() === "") {
        errors.VerifyToken = "Verify Token is required";
      }
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        await dispatch(
          AddOfficialWARegistration({ values: formData })
        ).unwrap();

        toast.success("WhatsApp Registration Successfully!", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
        });

        // Reset form
        setFormData({
          WhaClientName: "",
          UserName: "",
          Password: "",
          WhatsAppOffcialWa: "",
          DocLink: "",
          Templates: [],
          WhaCount: 0,
          WhaBalCount: 0,
          IsAdmin: false,
          IsActive: false,
          IsOWNWhatsapp: false,
          WhatsappBot: false,
          Database: "",
          Port: "",
          FolderName: "",
          WappNo: "",
          APIToken: "",
          PhoneNoID: "",
          VerifyToken: "",
          Server: ""
        });
      } catch (error) {
        toast.error(
          `Failed to add WhatsApp Registration: ${error.message || "Unknown error"
          }`,
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
          }
        );
      }
    } else {
      toast.error("Please fix validation errors.", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const handleCheckConnection = async () => {
    const { Port, UserName, Password, Database } = formData;

    if (!Port || !UserName || !Password || !Database) {
      toast.error(
        "Please fill all required fields (Port, Username, Password, Database)",
        {
          position: "top-center",
          autoClose: 2000,
          closeButton: true,
        }
      );
      return;
    }

    setIsChecking(true);
    toast.info("Checking connection...");

    try {
      await dispatch(
        CheckWAConnection({ Port, UserName, Password, Database })
      ).unwrap();
      toast.success("Connection successful!");
    } catch (err) {
      toast.error(`Connection failed: ${err}`);
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            WhatsApp Registration
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
          >
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Client Name</h5>
              <select
                name="WhaClientName"
                value={formData.WhaClientName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Client</option>
                {[...(AllClients?.data || [])]
                  .sort((a, b) =>
                    a.WhaClientName.localeCompare(b.WhaClientName)
                  )
                  .map((client) => (
                    <option key={client._id} value={client._id}>
                      {client.WhaClientName}
                    </option>
                  ))}
              </select>
              {errors.WhaClientName && (
                <p className="text-red-500 text-sm">{errors.WhaClientName}</p>
              )}
            </div>

            {/* Username Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Username</h5>
              <input
                type="text"
                name="UserName"
                placeholder="Enter Username"
                value={formData.UserName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.UserName && (
                <p className="text-red-500 text-sm">{errors.UserName}</p>
              )}
            </div>

            {/* Password Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6 relative">
              <h5 className="mb-1 block font-semibold">Password</h5>
              <input
                id="passwordInput"
                name="Password"
                type={showPassword ? "text" : "password"}
                value={formData.Password}
                onChange={handleChange}
                className="w-full border-2 border-black p-2 rounded pr-12 Form_bg_color"
                placeholder="Password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-[6%] top-[70%] transform -translate-y-1/2 text-sm text-gray-600"
              >
                {showPassword ? (
                  <BiSolidHide size={20} />
                ) : (
                  <BiSolidShow size={20} />
                )}
              </button>
              {errors.Password && (
                <p className="text-red-500 text-sm mt-1">{errors.Password}</p>
              )}
            </div>

            {/* WP API Setup Client Dropdown */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-[5px] block font-semibold">
                WP API Setup Client
              </h5>
              <select
                name="WhatsAppOffcialWa"
                value={formData.WhatsAppOffcialWa}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Name</option>
                {[...(WpSetupData || [])]
                  .sort((a, b) =>
                    (a.WhatsappOffcialName || "").localeCompare(
                      b.WhatsappOffcialName || ""
                    )
                  )
                  .map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.WhatsappOffcialName}
                    </option>
                  ))}
              </select>
              {errors.WhatsAppOffcialWa && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.WhatsAppOffcialWa}
                </p>
              )}
            </div>

            {/* Document Link Main Client Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-[5px] block font-semibold">
                Document Link Main Client
              </h5>
              <select
                name="DocLink"
                value={formData.DocLink}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Client</option>
                {[...(DocumentLinks || [])]
                  .sort((a, b) =>
                    (a.DocLinkName || "").localeCompare(b.DocLinkName || "")
                  )
                  .map((client) => (
                    <option key={client._id} value={client._id}>
                      {client.DocLinkName}
                    </option>
                  ))}
              </select>
              {errors.DocLink && (
                <p className="text-red-500 text-sm mt-1">{errors.DocLink}</p>
              )}
            </div>

            {/* Templates Dropdown */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Template</h5>
              <FormControl fullWidth>
                <InputLabel id="templates-select-label">Templates</InputLabel>
                <Select
                  labelId="templates-select-label"
                  id="Templates"
                  name="Templates"
                  multiple
                  className="bg-[#F3F8FB]"
                  value={formData.Templates}
                  onChange={(event) => {
                    const selectedIds = event.target.value;
                    const allRelatedIds = TemplateData.filter((template) =>
                      selectedIds.some(
                        (id) =>
                          TemplateData.find((t) => t._id === id)?.FormatID ===
                          template.FormatID
                      )
                    ).map((t) => t._id);

                    setFormData((prev) => ({
                      ...prev,
                      Templates: Array.from(new Set(allRelatedIds)),
                    }));
                  }}
                  input={
                    <OutlinedInput
                      label="Templates"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderWidth: "2px",
                          borderColor: "black",
                          color: "black",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "black",
                          color: "black",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "black",
                          color: "black",
                        },
                        "&.css-113d811-MuiFormLabel-root-MuiInputLabel-root": {
                          color: "black",
                        },
                        backgroundColor: "#F3F8FB",
                      }}
                    />
                  }
                  renderValue={(selected) => {
                    const selectedTemplates = TemplateData.filter((t) =>
                      selected.includes(t._id)
                    );
                    const uniqueFormats = [
                      ...new Set(selectedTemplates.map((t) => t.FormatID)),
                    ];
                    return uniqueFormats.join(", ");
                  }}
                  style={{ backgroundColor: "#F3F8FB" }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        marginTop: 8,
                      },
                    },
                  }}
                >
                  {[...(TemplateData || [])]
                    .sort((a, b) =>
                      (a.TemplateName || "").localeCompare(b.TemplateName || "")
                    )
                    .map((item) => (
                      <MenuItem key={item._id} value={item._id}>
                        <Checkbox
                          checked={formData.Templates.includes(item._id)}
                        />
                        <ListItemText
                          primary={`${item.FormatID}-${item.TemplateName}`}
                        />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>

            {/* Total Count Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Total Count</h5>
              <input
                type="number"
                name="WhaCount"
                // placeholder="Enter Static IP Number"
                value={formData.WhaCount}
                onChange={handleChange}
                readOnly
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.WhaCount && (
                <p className="text-red-500 text-sm">{errors.WhaCount}</p>
              )}
            </div>

            {/* Balance Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mt-1 block font-semibold">Balance</h5>
              <input
                type="number"
                name="WhaBalCount"
                value={formData.WhaBalCount}
                onChange={handleChange}
                readOnly
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {/* {errors.WhaBalCount && (
                <p className="text-red-500 text-sm">{errors.WhaBalCount}</p>
              )} */}
            </div>

            {/* Database Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mt-1 block font-semibold">Database</h5>
              <input
                type="text"
                name="Database"
                value={formData.Database}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.Database && (
                <p className="text-red-500 text-sm">{errors.Database}</p>
              )}
            </div>

            {/* Port Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mt-1 block font-semibold">Port</h5>
              <input
                type="number"
                name="Port"
                value={formData.Port}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.Port && (
                <p className="text-red-500 text-sm">{errors.Port}</p>
              )}
            </div>

            {/* Folder Name Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mt-1 block font-semibold">Folder Name</h5>
              <input
                type="text"
                name="FolderName"
                value={formData.FolderName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.FolderName && (
                <p className="text-red-500 text-sm">{errors.FolderName}</p>
              )}
            </div>

            {/* Server Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mt-1 block font-semibold">Server</h5>
              <input
                type="text"
                name="Server"
                value={formData.Server}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.Server && (
                <p className="text-red-500 text-sm">{errors.Server}</p>
              )}
            </div>

            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-3 block font-semibold">Options</h5>
              <div className="grid grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-4 gap-3">
                {/* Is Admin */}
                <label className="flex items-center space-x-3">
                  <input
                    id="Is Admin"
                    type="checkbox"
                    name="CheckConnection"
                    checked={formData.CheckConnection || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        CheckConnection: e.target.checked,
                      }))
                    }
                    className="appearance-none w-5 h-5 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500"
                  />
                  <span className="text-base font-semibold">Is Admin</span>
                </label>

                {/* Is Active */}
                <label className="flex items-center space-x-3">
                  <input
                    id="CheckVersion"
                    type="checkbox"
                    name="CheckVersion"
                    checked={formData.CheckVersion || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        CheckVersion: e.target.checked,
                      }))
                    }
                    className="appearance-none w-5 h-5 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500"
                  />
                  <span className="text-base font-semibold">Is Active</span>
                </label>

                {/* Is Own WhatsApp */}
                <label className="flex items-center space-x-3">
                  <input
                    id="IsOWNWhatsapp"
                    type="checkbox"
                    name="IsOWNWhatsapp"
                    checked={formData.IsOWNWhatsapp || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        IsOWNWhatsapp: e.target.checked,
                      }))
                    }
                    className="appearance-none w-5 h-5 p-2 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500"
                  />
                  <span className="text-base font-semibold white">
                    Own WhatsApp
                  </span>
                </label>

                {/* WhatsApp Bot */}
                <label className="flex items-center space-x-3">
                  <input
                    id="WhatsappBot"
                    type="checkbox"
                    name="WhatsappBot"
                    checked={formData.WhatsappBot || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        WhatsappBot: e.target.checked,
                      }))
                    }
                    className="appearance-none w-5 h-5 p-2 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500"
                  />
                  <span className="text-base font-semibold white">
                    Whatsapp Bot
                  </span>
                </label>
              </div>
            </div>

            {/* Whatsapp Bot Fields - Only Show if Checked */}
            {formData.WhatsappBot && (
              <>
                <div className="col-span-12 lg:col-span-4 md:col-span-6">
                  <h5 className="mb-1 block font-semibold">Whatsapp No</h5>
                  <input
                    type="text"
                    name="WappNo"
                    value={formData.WappNo}
                    onChange={handleChange}
                    className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                  />
                  {errors.WappNo && <p className="text-red-500 text-sm">{errors.WappNo}</p>}
                </div>

                <div className="col-span-12 lg:col-span-4 md:col-span-6">
                  <h5 className="mb-1 block font-semibold">API Token</h5>
                  <input
                    type="text"
                    name="APIToken"
                    value={formData.APIToken}
                    onChange={handleChange}
                    className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                  />
                  {errors.APIToken && <p className="text-red-500 text-sm">{errors.APIToken}</p>}
                </div>

                <div className="col-span-12 lg:col-span-4 md:col-span-6">
                  <h5 className="mb-1 block font-semibold">Phone No ID</h5>
                  <input
                    type="text"
                    name="PhoneNoID"
                    value={formData.PhoneNoID}
                    onChange={handleChange}
                    className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                  />
                  {errors.PhoneNoID && <p className="text-red-500 text-sm">{errors.PhoneNoID}</p>}
                </div>

                <div className="col-span-12 lg:col-span-4 md:col-span-6">
                  <h5 className="mb-1 block font-semibold">Verify Token</h5>
                  <input
                    type="text"
                    name="VerifyToken"
                    value={formData.VerifyToken}
                    onChange={handleChange}
                    className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                  />
                  {errors.VerifyToken && <p className="text-red-500 text-sm">{errors.VerifyToken}</p>}
                </div>
              </>
            )}

            {/* Submit Button */}
            <div className="submit_Form col-span-12 flex justify-center">
              <button type="submit" className="All_button">
                Submit
              </button>
            </div>
          </form>

          <div
            onClick={handleCheckConnection}
            className="submit_Form col-span-12 flex justify-center pb-3"
          >
            <button className="All_button">
              {isChecking ? "Checking..." : "Check Connection"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhatsAppRegistration;
